// extracted by mini-css-extract-plugin
module.exports = {"content":"Collections_content__32Z0r"};